<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:500px;" class="mb-2">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="运单编号搜索..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group size="sm">
          <b-button
            v-allow="'actCancelSendWaybill'"
            size="sm"
            class="ml-2"
            variant="outline-danger"
            @click="batchCancel()"
          >
            <i class="el-icon-refresh-left"></i>
            取消派单
          </b-button>
          <b-button
            v-allow="'actPrintWaybill'"
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="batchPrint()"
          >
            <i class="el-icon-printer"></i>
            运单打印
          </b-button>
          <el-dropdown trigger="click" @command="batchExport" size="medium">
            <b-button
              v-allow="'actExportWaybill'"
              size="sm"
              variant="outline-success"
              class="ml-2 mr-2"
            >
              <i class="el-icon-download"></i>
              派单数据导出
              <i class="el-icon-caret-bottom"></i>
            </b-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{
                  type: 'choose',
                }"
                >导出已选中<span class="badge-item">{{totCount}}</span></el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 'time'}"
                >导出最近30天数据</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </b-input-group>
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="90px">
        <el-row :gutter="10">
          <!-- <el-col :span="24">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="form.setDateRange"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="运单编号">
              <el-input
                v-model="form.waybillNo"
                placeholder="请输入运单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="承运商名称">
              <dict-select
                style="width:100%"
                v-model="form.carrierCode"
                clearable
                filterable
                url="/master/carrier/info/select"
                placeholder="请选择承运商"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import util from '@/libs/util'
// 初始表单
const initForm = {
  keyword: '',
  wayBillStatusList: ['2'],
  timeType: '1',
  setDateRange: []
}
export default {
  data() {
    return {
      //订单类型下拉请求参数
      orderTypeDictParams: { type: 'orderType' },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              let startDate = util.formatDate(start, 'begin')
              let endDate = util.formatDate(end, 'end')
              picker.$emit('pick', [startDate, endDate])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              let startDate = util.formatDate(start, 'begin')
              let endDate = util.formatDate(end, 'end')
              picker.$emit('pick', [startDate, endDate])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              let startDate = util.formatDate(start, 'begin')
              let endDate = util.formatDate(end, 'end')
              picker.$emit('pick', [startDate, endDate])
            }
          }
        ]
      },
      form: { ...initForm },
      advqueryDialogVisible: false,
      totCount: 0,
    }
  },
  created() {
    this.resetTime()
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.resetTime()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    resetTime() {
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      let startDate = util.formatDate(start, 'begin')
      let endDate = util.formatDate(new Date(), 'end')
      this.form.setDateRange = [startDate, endDate]
    },
    batchCancel() {
      this.$emit('batchCancel')
    },
    batchPrint() {
      this.$emit('batchPrint')
    },
    batchExport(data) {
      const type = data.type
      this.$emit('batchExport',type)
    },
    changeTable(type) {
      this.$emit('changeTable', type)
    },
    updateTotCount(val){
      this.totCount = val
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.mt-2p {
  margin-top: 2px;
}
.line {
  text-align: center;
}
.badge-item {
  font-size: 12px;
  color: #ffffff;
  background-color: #F56C6C;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 50px;
  margin-left: 5px;
}
</style>
